module.exports = __webpack_public_path__ + "img/sld_mppt_1_t1_b1.734ac61e.svg";